'use client';

import { c as _c } from "react/compiler-runtime";
import { formatDistanceToNow } from '@repo/sdk/date';
import React, { useEffect, useState } from 'react';
export const TimeAgo = t0 => {
  const $ = _c(13);
  const {
    dateTime,
    onClick
  } = t0;
  const [trigger, setTrigger] = useState(0);
  const [intervalDuration, setIntervalDuration] = useState(1000);
  let t1;
  if ($[0] !== dateTime) {
    t1 = () => {
      const updateInterval = () => {
        const now = new Date();
        const targetDate = new Date(dateTime);
        const diffInSeconds = Math.abs((now.getTime() - targetDate.getTime()) / 1000);
        const diffInMinutes = diffInSeconds / 60;
        const diffInHours = diffInMinutes / 60;
        const diffInDays = diffInHours / 24;
        if (diffInMinutes < 1) {
          return 1000;
        }
        if (diffInMinutes < 60) {
          return 60000;
        }
        if (diffInHours < 24) {
          return 3600000;
        }
        if (diffInDays >= 1) {
          const nextDay = new Date();
          nextDay.setHours(0, 0, 0, 0);
          nextDay.setDate(nextDay.getDate() + 1);
          return nextDay.getTime() - now.getTime();
        }
        return 3600000;
      };
      const newInterval = updateInterval();
      setIntervalDuration(newInterval);
    };
    $[0] = dateTime;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== dateTime || $[3] !== trigger) {
    t2 = [dateTime, trigger];
    $[2] = dateTime;
    $[3] = trigger;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[5] !== intervalDuration) {
    t3 = () => {
      const intervalId = setInterval(() => {
        setTrigger(_temp);
      }, intervalDuration);
      return () => clearInterval(intervalId);
    };
    t4 = [intervalDuration];
    $[5] = intervalDuration;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== dateTime) {
    t5 = formatDistanceToNow(dateTime);
    $[8] = dateTime;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onClick || $[11] !== t5) {
    t6 = <p className="text-sm" onClick={onClick}>{t5}</p>;
    $[10] = onClick;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
function _temp(prev) {
  return prev + 1;
}